import { useStaticData } from '@mc/static-data-react'
import type { Course } from '@mc/api'

import { CategoryBreadcrumbBar } from 'components/CategoryBreadcrumbBar'
import { PrimaryCategoryAndSubcategory } from 'libs/server/api/growth'

export const ClassCategoryBreadcrumbBar = () => {
  const { course, primaryGrowthCatAndSubcat } = useStaticData<{
    course: Course
    primaryGrowthCatAndSubcat: PrimaryCategoryAndSubcategory
  }>()

  if (!primaryGrowthCatAndSubcat) return <></>

  const { primaryCategory, primarySubcategory } = primaryGrowthCatAndSubcat

  return (
    <CategoryBreadcrumbBar
      course={course}
      category={primaryCategory}
      subcategory={primarySubcategory}
    />
  )
}
